export default function Card(props) {
    return (
        <div
            style={{ 
                padding: '20px 20px 20px 20px', 
                backgroundColor: '#fff', 
                borderRadius: '10px',
                position: 'relative', 
                zIndex: 1,
                boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
            }}
        >
                {props.children}
        </div>
    )
}
